import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Http } from '../../services/http/http.service';
import { BaseComponent } from '../base/base.component';
import {
  PickListComponent,
  PickListGroup,
} from '../core/controls/pick-list.component';
import { ApiErrorLabelComponent } from '../core/labels/api-error-label.component';
import { ErrorComponent } from '../core/labels/error.component';
import { LinkLabelComponent } from '../core/labels/link-label.component';
import { DialogComponent } from '../core/panels/dialog.component';
import { LoadingPanelComponent } from '../core/panels/loading-panel.component';
import { PanelComponent } from '../core/panels/panel.component';
import { HomeCardComponent } from '../home/home-card.component';
import { FieldSearchComponent } from '../view/field-search/field-search.component';
import { ApiDesignComponent } from './api-design.component';
import { CardDesignComponent } from './card-design.component';
import { ColorDesignComponent } from './color-design.component';
import { DialogDesignComponent } from './dialog-design.component';
import { FormPrimeDesignComponent } from './form-prime-design.component';
import { MenuDesignComponent } from './menu-design.component';
import { TabPanelDesignComponent } from './tab-panel-design.component';
import { TableDesignComponent } from './table-design.component';

@Component({
  selector: 'app-design-page',
  imports: [
    CommonModule,
    PanelComponent,
    ErrorComponent,
    LoadingPanelComponent,
    ApiDesignComponent,
    TableDesignComponent,
    FormPrimeDesignComponent,
    MenuDesignComponent,
    DialogDesignComponent,
    ColorDesignComponent,
    FieldSearchComponent,
    DialogComponent,
    TabPanelDesignComponent,
    ApiErrorLabelComponent,
    CardDesignComponent,
    PickListComponent,
    LinkLabelComponent,
    HomeCardComponent,
  ],
  template: `
    <div class="tw-grow tw-w-full tw-justify-center">
      <app-home-card type="Large">
        <div class="tw-pb-8 tw-w-full tw-min-w-0">
          <app-panel [showExpand]="true" label="Picklist" [expanded]="true">
            <div class="tw-flex tw-items-center tw-gap-4 tw-pb-8">
              <span>count:</span> <input value="10" #countInput />
              <span>label:</span>
              <input value="item" #labelInput />
              <button (click)="loadItems(labelInput.value, countInput.value)">
                Load
              </button>
            </div>

            <app-pick-list
              [sourceControl]="availableControl"
              [targetControl]="selectedControl"
              labelName="label"
              keyName="value"
              [showAddRemoveAll]="true"
              #picklist
            />
            <div>
              selectedSource: {{ picklist.selectedSource.value | json }}
            </div>
            <div>selected: {{ selectedControl.value | json }}</div>

            <div>availableControl: {{ availableControl.value | json }}</div>
          </app-panel>

          <app-panel [expanded]="true" label="Colors and Fonts">
            <app-color-design />
          </app-panel>

          <app-panel label="Table" [expanded]="true">
            <app-table-design></app-table-design>
          </app-panel>

          <app-panel label="Forms PrimeNg" [expanded]="true">
            <app-form-prime-design></app-form-prime-design>
          </app-panel>

          <app-panel
            [showExpand]="true"
            label="Api Error Label"
            [expanded]="true"
          >
            <app-card-design />
          </app-panel>
          <app-panel
            [showExpand]="true"
            label="Api Error Label"
            [expanded]="true"
          >
            <app-api-error-label [error]="apiError"></app-api-error-label>
            <div class="tw-py-4 tw-flex tw-gap-8">
              <app-link-label routerLink="" (click)="callApiError(400)"
                >400</app-link-label
              >
              <app-link-label routerLink="" (click)="callApiError(401)"
                >401</app-link-label
              >
              <app-link-label routerLink="" (click)="callApiError(403)"
                >403</app-link-label
              >
              <app-link-label routerLink="" (click)="callApiError(500)"
                >500</app-link-label
              >
              <app-link-label routerLink="" (click)="callApiError(0)"
                >Custom</app-link-label
              >
            </div>
          </app-panel>

          <app-panel label="Tab Panel" [expanded]="true">
            <app-tab-panel-design></app-tab-panel-design>
          </app-panel>

          <app-panel label="Field Search" [expanded]="true">
            <button (click)="fieldDialog.visible = true">Show dialog</button>
            <app-dialog #fieldDialog label="Field Search" [closable]="true">
              <ng-template #content>
                <app-field-search></app-field-search>
              </ng-template>
            </app-dialog>
          </app-panel>

          <app-panel label="Dialog" [expanded]="false">
            <app-dialog-design />
          </app-panel>

          <app-panel label="Menu" [expanded]="false">
            <app-menu-design></app-menu-design>
          </app-panel>

          <app-panel [showExpand]="true" label="Api" [expanded]="false">
            <app-api-design></app-api-design>
          </app-panel>

          <app-panel
            [showExpand]="true"
            label="Loading panels"
            [expanded]="false"
          >
            <h3>Error Label</h3>
            <app-error error="test"></app-error>

            <h3>Svg Loader</h3>
            <app-loading-panel
              state="Loading"
              error=""
              loadingStyle="Image"
              loadingImageSrc="/assets/images/loader/search-results-ghost.svg"
            >
              <ng-template #loaded>Im loaded</ng-template>
              <ng-template #empty>Im empty</ng-template>
            </app-loading-panel>

            <h3>Box Loader</h3>
            <app-loading-panel
              state="Loading"
              loadingStyle="Box"
              [loadingHeight]="200"
            ></app-loading-panel>

            <h3>Skeleton Loader</h3>
            <app-loading-panel
              state="Loading"
              loadingStyle="Skeleton"
              [loadingHeight]="215"
            ></app-loading-panel>

            <h3>Dot Loader</h3>
            <app-loading-panel
              state="Loading"
              loadingStyle="Dot"
              [loadingHeight]="215"
            ></app-loading-panel>
          </app-panel>
        </div>
      </app-home-card>
    </div>
  `,
  styles: ``,
})
export class DesignPageComponent extends BaseComponent {
  http = inject(Http);

  apiError: any = null;

  selectedControl = new FormControl<any[]>([]);

  availableControl = new FormControl<any[]>([
    {
      label: 'Item 1',
      value: 1,
    },
    {
      label: 'Item 2',
      value: 2,
    },
  ]);

  available2Control = new FormControl<PickListGroup[]>([
    new PickListGroup('Group 1', [
      {
        label: 'Item 1',
        value: 1,
      },
      {
        label: 'Item 2',
        value: 2,
      },
    ]),
    new PickListGroup('Group 2', [
      {
        label: 'Item 3',
        value: 3,
      },
      {
        label: 'Item 4',
        value: 4,
      },
    ]),
  ]);

  loadItems(label: string, count: string) {
    const items: any[] = [];
    // add 10000
    for (let index = 0; index < parseInt(count); index++) {
      items.push({
        label: label + ' ' + index,
        value: index,
      });
    }

    this.availableControl.setValue(items);
    this.selectedControl.setValue([]);
  }

  async callApiError(code: number) {
    if (code === 0) {
      this.apiError = 'Custom error message';
    } else {
      try {
        this.apiError = null;
        await this.http.get('api/test/' + code);
      } catch (error) {
        this.apiError = error;
      }
    }
  }
}
